/**
 * useDeleteTransaction Hook
 *
 * 거래 삭제 Hook
 * - 공유 transactionRepository 싱글톤을 통해 거래 삭제
 * - 로딩/에러 상태 관리
 *
 * @why 매 렌더링마다 new GoogleSheetsTransactionRepository()로 인스턴스를
 * 새로 만들면 메모리 누수 + 테스트 시 의존성 주입 불가 문제가 있어
 * '../repositories'의 싱글톤을 사용하도록 통일.
 */

import { useState } from 'react'
import { transactionRepository } from '../repositories'

export function useDeleteTransaction() {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const deleteTransaction = async (id: string) => {
    setLoading(true)
    setError(null)

    try {
      await transactionRepository.delete(id)
    } catch (err) {
      const message = err instanceof Error ? err.message : '거래 삭제에 실패했습니다'
      setError(message)
      throw err
    } finally {
      setLoading(false)
    }
  }

  return {
    deleteTransaction,
    loading,
    error,
  }
}
